/** ************************************************************************************
 * PLAN YOUR JOURNEY
 */

function resetPlanYourJourneyForm() {
    $("#input-start-from").val("");
    $("#input-start-from-hidden").val("");
    $("#input-go-to").val("");
    $("#input-go-to-hidden").val("");
    $("#input-go-to").val("");
    $("#input-go-to-hidden").val("");
    $("#input-start-time").val("");
    $("#input-start-date").val("");
}

/* ************************************************************************************
 * SEARCH
 */

var app = angular.module('searchGeolocation', ['ngSanitize', 'ngRoute', 'angularSpinner', 'ngAria', 'mp.deepBlur']).config(function($interpolateProvider, usSpinnerConfigProvider){
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');

    usSpinnerConfigProvider.setDefaults({
        lines: 13,
        length: 50,
        width: 15,
        radius: 60,
        scale: 0.15,
        color: '#818181'
    });
});

//
app.controller('searchGeolocationController', ['$scope', '$http', '$timeout', '$q', 'usSpinnerService', '$element', function($scope, $http, $timeout, $q, usSpinnerService, $element){

    $scope.showNoResultsInputStartFrom = false;
    $scope.showNoResultsInputGoTo = false;

    $scope.defaultDropdownItems = '';

    $scope.dropdownItems = $scope.defaultDropdownItems || [];

    /*
     * geolocalizzazione
     */
    $scope.geolocate = function() {

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){
                $scope.$apply(function(){
                    $scope.position = position;
                });
            });
        }
    };

    $scope.url = Routing.generate("autocomplete_address_def"); // The url of our search
    $scope.urlDetail = Routing.generate("autocomplete_address_def_detail"); // The url of our search


    /**
     * funzione chiamata alla chiusura della finestra dropdown
     */
    $scope.hideDropdown = function(target) {
        // se il value del campo input nascosto è vuoto
        // cancella il contenuto del campo input principale
        if($('#' + target + '-hidden').val() == "") {
            $scope.checkForClean(target);
        }

        // imposto l'altezza della lista a 0 per risolvere un problema su FF
        $('.search-list').css('height', '0');
    }

    /*
     * funzione eseguita all'ng-change della stringa di input nel campo "partenza" e "arrivo"
     */
    var canceller = $q.defer();
    $scope.search = function(target) {

        // console.log('search');

        canceller.resolve("cancelled"); // Resolve the previous canceler
        canceller = $q.defer();

        if(target == 'input-start-from') {

            $("#input-start-from-hidden").val("");
            $scope.geolocationResultsInputStartFrom = [];
            $scope.showNoResultsInputStartFrom = false;

            $scope.dropdownItems = $scope.defaultDropdownItems || [];

            var string = $scope.startFrom;

            if(string && string.length > 3) {
                usSpinnerService.spin('spinner-loading-input-start-from');

                $scope.callSearch(string, "input-start-from");
            }
            else if(!string){
                $scope.resetSearch('input-start-from');
            }

        } else if(target == 'input-go-to') {

            $("#input-go-to-hidden").val("");
            $scope.geolocationResultsInputGoTo = [];
            $scope.showNoResultsInputGoTo = false;

            $scope.dropdownItems = $scope.defaultDropdownItems || [];

            var string = $scope.goTo;

            if(string && string.length > 3) {
                usSpinnerService.spin('spinner-loading-input-go-to');

                $scope.callSearch(string, "input-go-to");

            }
            else if(!string){
                $scope.resetSearch('input-go-to');
            }

        }
    };

    /**
     * resetta la ricerca
     */
    $scope.resetSearch = function(target) {

        if(target == 'input-start-from') {
            $scope.geolocationResultsInputStartFrom = [];
            $scope.showNoResultsInputStartFrom = false;
            $scope.isExpandedStartFrom = false;
            usSpinnerService.stop('spinner-loading-input-start-from');

        } else if(target == 'input-go-to') {
            $scope.geolocationResultsInputGoTo = [];
            $scope.showNoResultsInputGoTo = false;
            $scope.isExpandedGoTo = false;
            usSpinnerService.stop('spinner-loading-input-go-to');

        }

        if(searchPromise) {
            // $timeout.cancel(searchPromise);
        }
    };

    /**
     * CALL
     */
    var searchPromise;

    $scope.callSearch = function(string, target) {
        // console.log('callSearch');

        if(target == "input-start-from") {
            $scope.showNoResultsInputStartFrom = false;
            $scope.geolocationResultsInputStartFrom = [];
        } else if(target == "input-go-to") {
            $scope.showNoResultsInputGoTo = false;
            $scope.geolocationResultsInputGoTo = [];
        }

        if(searchPromise){
            $timeout.cancel(searchPromise);
        }
        searchPromise = $timeout(function () {
            var geoRequestId = uniqid();

            $http.get($scope.url, {
                "data" : $scope,
                "params": {
                    string: string,
                    geoRequestId: geoRequestId
                },
                timeout: canceller.promise
            }).then(function(data, status) {

                usSpinnerService.stop('spinner-loading-' + target);

                // imposto l'altezza della lista a 'auto' per risolvere un problema su FF
                if(target == "input-start-from") {
                    $('.search-list-input-start-from').css('height', 'auto');
                } else if(target == "input-go-to") {
                    $('.search-list-input-go-to').css('height', 'auto');
                }

                if(data.data.results.length == 0) {
                    if(target == "input-start-from") {
                        $scope.showNoResultsInputStartFrom = true;
                    } else if(target == "input-go-to") {
                        $scope.showNoResultsInputGoTo = true;
                    }
                }

                if(data.data.geoRequestId == geoRequestId) {
                    if(target == "input-start-from") {
                        $scope.geolocationResultsInputStartFrom = data.data.results;
                        $scope.dropdownItems = $scope.geolocationResultsInputStartFrom;
                        $scope.isExpandedStartFrom = true;
                    } else if(target == "input-go-to") {
                        $scope.geolocationResultsInputGoTo = data.data.results;
                        $scope.dropdownItems = $scope.geolocationResultsInputGoTo;
                        $scope.isExpandedGoTo = true;
                    }
                }

            }, function () {
                return [];
            });
        },1500);
    };

    $scope.cancel = function(){
        canceller.resolve("user cancelled");
    };

    $scope.setStop = function(target, coords, stopId, term){
        // console.log('setStop', target, coords, stopId, term);
        if (coords) {
            $('#' + target + '-hidden').val(coords);
        } else {
            // console.log(stopId);
            if (stopId) {
                $http.get($scope.urlDetail, {
                    "data" : $scope,
                    "params": {
                        place_id: stopId,
                        term: term
                    }
                }).then(function(data, status) {

                    // console.log(data);

                    $('#' + target + '-hidden').val(data.data.coords);

                }, function () {
                    alert('Ops! Si è verificato un errore.');
                });
            } else {
                alert('Ops! Si è verificato un errore.');
            }
        }
    };

    $scope.setStopString = function(target, description) {
        // console.log('setStopString', target, description);
        setTimeout(function () {
            if(target == 'input-start-from') {
                $scope.startFrom = description;
            } else if(target == 'input-go-to') {
                $scope.goTo = description;
            }
            $('#' + target).val(description);
            $('#' + target).trigger('click');
        }, 500);
    };

    $scope.checkForClean = function(target) {

        if(target == 'input-start-from') {
            $scope.startFrom = "";
        } else if(target == 'input-go-to') {
            $scope.goTo = "";
        }

        $("#" + target).val("");
        usSpinnerService.stop('spinner-loading-' + target);
        $scope.resetSearch(target);

    };
}]);
